var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCannedAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86544 2.24413 6.20163C1.69067 7.53781 1.54586 9.00811 1.82801 10.4266C2.11017 11.8451 2.80661 13.148 3.82928 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4541 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3106 7.06118 15.5396 5.20229 14.1687 3.83134C12.7977 2.46038 10.9388 1.68936 9 1.6875ZM11.8125 9.5625H9.5625V11.8125C9.5625 11.9617 9.50324 12.1048 9.39775 12.2102C9.29226 12.3157 9.14919 12.375 9 12.375C8.85082 12.375 8.70775 12.3157 8.60226 12.2102C8.49677 12.1048 8.4375 11.9617 8.4375 11.8125V9.5625H6.1875C6.03832 9.5625 5.89525 9.50324 5.78976 9.39775C5.68427 9.29226 5.625 9.14918 5.625 9C5.625 8.85082 5.68427 8.70774 5.78976 8.60225C5.89525 8.49676 6.03832 8.4375 6.1875 8.4375H8.4375V6.1875C8.4375 6.03832 8.49677 5.89524 8.60226 5.78975C8.70775 5.68426 8.85082 5.625 9 5.625C9.14919 5.625 9.29226 5.68426 9.39775 5.78975C9.50324 5.89524 9.5625 6.03832 9.5625 6.1875V8.4375H11.8125C11.9617 8.4375 12.1048 8.49676 12.2103 8.60225C12.3157 8.70774 12.375 8.85082 12.375 9C12.375 9.14918 12.3157 9.29226 12.2103 9.39775C12.1048 9.50324 11.9617 9.5625 11.8125 9.5625Z",
    fill: "url(#paint0_linear_348_621)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_348_621",
    x1: 1.6875,
    y1: 9,
    x2: 16.3125,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannedAdd);
export default __webpack_public_path__ + "static/media/canned_add.665bd3eb696b65f19618dc59188a09b3.svg";
export { ForwardRef as ReactComponent };